import { useState } from "react";
import API from "../axios";

interface AttributeValue {
    attributeValueName: string;
    attributeValueOdooId: string;
    image: string | null;
    _id: string;
}

interface ColorAttributeValuesProps {
    datas: AttributeValue[];
    handleColorUpdated: (id: string, color: string) => void;
}

const ColorAttributeValues = function (props: ColorAttributeValuesProps) {
    const [colorUpdating, setColorUpdating] = useState(false);

    // Local state for each color by _id
    const [colors, setColors] = useState<Record<string, string>>(() => {
        const initialColors: Record<string, string> = {};
        props.datas.forEach((item) => {
            initialColors[item._id] = item.image || "#cccccc"; // fallback to gray
        });
        return initialColors;
    });

    const handleColorChange = async (
        _id: string,
        odooId: number,
        color: string
    ) => {
        setColorUpdating(true);

        // Update local state
        setColors((prev) => ({
            ...prev,
            [_id]: color,
        }));

        try {
            await API.createLocalAttributeImage(odooId, color);
            props.handleColorUpdated?.(_id, color); // optional external callback
        } catch (err) {
            console.error("Failed to update color:", err);
        }

        setColorUpdating(false);
    };

    return (
        <div>
            <table className="table mt-3">
                <thead>
                    <tr>
                        <th>Attribute Value Name</th>
                        <th>Color Code</th>
                    </tr>
                </thead>
                <tbody>
                    {props.datas.map((attributeValue) => (
                        <tr key={attributeValue._id}>
                            <td>{attributeValue.attributeValueName}</td>
                            <td className="d-flex flex-row">
                                <input
                                    type="color"
                                    value={colors[attributeValue._id]}
                                    style={{
                                        border: "1px solid gray",
                                        borderRadius: 5,
                                        opacity: colorUpdating ? "80%" : "100%",
                                    }}
                                    onChange={(e) =>
                                        handleColorChange(
                                            attributeValue._id,
                                            parseInt(
                                                attributeValue.attributeValueOdooId
                                            ),
                                            e.target.value
                                        )
                                    }
                                    disabled={colorUpdating}
                                />
                                <p className="mx-2">{colors[attributeValue._id] == "#cccccc" && "(empty color)"}</p>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ColorAttributeValues;
